// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Daa","tabsBox":"styles_tabsBox__T2q3c","createButton":"styles_createButton__324zl"};